import React from "react";
import { Pressable } from "react-native";
import { CloseIcon, Input, InputField, InputIcon, InputSlot } from "components/ui";

type TextboxProps = {
	placeholder?: string;
	value?: string;
	onChange?: (text: string) => void;
	onBlur?: (text?:string) => void;
};

export const Textbox: React.FC<TextboxProps> = ({ placeholder, value, onChange, onBlur }) => {
	return (
		<Input
			flex={1}
			px="$0"
			borderWidth={0}
			borderBottomWidth={1}
			borderRadius={0}
			borderColor="$neutral200"
			py="$3"
			isDisabled={false}
			isInvalid={false}
			isReadOnly={false}
			style={{
				zIndex: 100,
			}}
			isFocused={true}
			isHovered={true}
		>
			<InputField borderWidth={0} fontSize={16} borderRadius={"$lg"} placeholder={placeholder} value={value} onChangeText={onChange} color="$basicblack" placeholderTextColor={"#cccccc"} />
			{value &&<InputSlot>
				<Pressable onPress={() => onChange && onChange("")} onBlur={onBlur}>
					<InputIcon as={CloseIcon} mr="$4" color={"$textLight400"} />
				</Pressable>
			</InputSlot>}
		</Input>
	);
};
